import { IObserver, IMapData, INode, INodesList, IDatastore, IGridCells, IAssociation } from "./interface";
const Popup_TEMPLATE = require("./view/popup.handlebars");

export class AtlasPopup implements IObserver<IMapData> {
  public data: INodesList;
  private node: IAssociation;
  public associations: IMapData;
  private association: any;
  private Alphabet: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  private visible: boolean = false;
  private x: number;
  private y: number;

  public constructor(private nodes: INodesList, private datastore: IDatastore<any, any>) {
    this.Render();
  }

  public ReceiveUpdate(Data: INodesList, Associations: IMapData) {
    this.data = Data;
    this.associations = Associations;
    Data.nodes.map((item, index) => {
      if (Associations) {

        this.association = Associations.nodes.find(value => Number(value.gameserverId) === Number(item.id));
        if (this.association) {
          this.data.nodes[index].alias = this.Alphabet[this.association.cell.gridX] + Math.round(Number(this.association.cell.gridY) + 1);
        }
      }
    });

    this.UpdateView();

    if (this.visible) {
      this.Show(this.node, this.x, this.y);
    }
  }

  public UpdateData(data) {
    const associationByPosition = this.associations.nodes.find((item) => item.cell.gridY === data.x && item.cell.gridX === data.y);
    const associationById = this.associations.nodes.find((item) => Number(item.gameserverId) === Number(data.gameserverId));

    this.associations.nodes.map((item, index) => {
      if (item.cell.gridY === this.y && item.cell.gridX === this.x) {
        const pos = this.associations.nodes[index].cell;
        this.associations.nodes[index].cell.gridY = -1;
        this.associations.nodes[index].cell.gridX = -1;
      }

      if (Number(item.gameserverId) === Number(data.gameserverId)) {
        this.associations.nodes[index].cell.gridX = data.x;
        this.associations.nodes[index].cell.gridY = data.y;
        this.node = this.associations.nodes[index];
      }
    });

    this.datastore.UpdateAssociations(this.associations);
  }

  public Show(node: IAssociation, x: number, y: number) {
    this.node = node;
    this.x = x;
    this.y = y;
    this.UpdateView();
    $(".atlas-map__popup").show();
    this.visible = true;
  }

  public Bind() {
    $(".atlas-map__popup")
      .find(".atlas-map__popup__item")
      .on("click", (e) => {
        const x = this.x;
        const y = this.y;
        const gameserverId = $(e.currentTarget).data('node');
        this.UpdateData({y, x, gameserverId});
      });

    $(".atlas-map__popup").find(".atlas-map__popup__close").on("click", () => {
      this.Hide();
    });
  }

  public Hide() {
    $(".atlas-map__popup").hide();
    this.visible = false;
  }

  public UpdateView() {
    $(".atlas-map__popup").replaceWith(Popup_TEMPLATE({
        nodes: this.nodes.nodes,
        node: this.node,
        association: this.association
      }));

    this.Bind();
  }

  public Render() {
    $("body").append(Popup_TEMPLATE({
        nodes: this.nodes.nodes,
        node: this.node
      }));

    this.Bind();
  }
}
